export default "__VITE_ASSET__BUSY_30L__"